'use client'

import Link from "next/link"
import { useState } from "react"
import { Button } from "@/ui/shadcn/button"
import { useModal } from "../context/ModalContext"
import { useAuth } from "../context/AuthContext"
import LoginModal from "../context/modals/Login"
export default function SellButton() {

    const [popinOpened, setPopinOpened] = useState(false)
    const { openModal, closeModal } = useModal()
    const { user } = useAuth()
    
	return (
		<>
            { user ? (
                <Link href="/product/create">
                    <Button size={'default'}>Vendez des articles</Button>
                </Link>
            ) : (
                <Link
                    href="#"
                    onClick={() => openModal(<LoginModal closeAction={closeModal} />)}
                    className="text-black font-semibold text-sm"
                >
                    <Button size={'default'}>Vendez des articles</Button>
                </Link>
            )}
        </>
	)
}